var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMenuFoodcourts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9375 1.65625H4.83594L2.44922 6.42969V8.82031C2.44922 10.1367 3.51953 11.207 4.83594 11.207C6.15625 11.207 7.22266 10.1367 7.22266 8.82031C7.22266 10.1367 8.29297 11.207 9.61328 11.207C10.9297 11.207 12 10.1367 12 8.82031C12 10.1367 13.0664 11.207 14.3867 11.207C15.707 11.207 16.7734 10.1367 16.7734 8.82031C16.7734 10.1367 17.8438 11.207 19.1602 11.207C20.4805 11.207 21.5508 10.1367 21.5508 8.82031C21.5508 10.1367 22.6172 11.207 23.9375 11.207C25.2539 11.207 26.3242 10.1367 26.3242 8.82031V6.42969L23.9375 1.65625Z",
    stroke: "#240b3b",
    strokeWidth: 2.3875,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3867 17.168C17.0234 17.168 19.1602 19.3047 19.1602 21.9453V23.1953H9.61328V21.9453C9.61328 19.3047 11.75 17.168 14.3867 17.168Z",
    stroke: "#240b3b",
    strokeWidth: 2.3875,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3867 14.7812V17.168",
    stroke: "#240b3b",
    strokeWidth: 2.3875,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22266 23.1328H21.5508",
    stroke: "#240b3b",
    strokeWidth: 2.3875,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0742188 27.9062H28.6992",
    stroke: "#240b3b",
    strokeWidth: 2.3875,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64844 10.0078V27.9063",
    stroke: "#240b3b",
    strokeWidth: 2.3875,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.125 10.0078V27.9063",
    stroke: "#240b3b",
    strokeWidth: 2.3875,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44922 6.42969H26.3242",
    stroke: "#240b3b",
    strokeWidth: 2.3875,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22266 6.42969V8.82031",
    stroke: "#240b3b",
    strokeWidth: 2.3875,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.42969V8.82031",
    stroke: "#240b3b",
    strokeWidth: 2.3875,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7734 6.42969V8.82031",
    stroke: "#240b3b",
    strokeWidth: 2.3875,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5508 6.42969V8.82031",
    stroke: "#240b3b",
    strokeWidth: 2.3875,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMenuFoodcourts);
export default __webpack_public_path__ + "static/media/new-menu-foodcourts.7122107edfe952c6936ac09d0d607524.svg";
export { ForwardRef as ReactComponent };